// Replaces vuejs-noty (Vue 2 only): the same wrapper over noty, available as app.noty and this.$noty.
// Styles: noty's CSS in app.scss.
import Noty from 'noty'

const defaults = {
  layout: 'topRight',
  theme: 'mint',
  timeout: 5000,
  progressBar: true,
  closeWith: ['click'],
}

const createNoty = (options) => {
  const show = (text, type = 'alert', opts = {}) => {
    const noty = new Noty({ ...options, ...opts, type, text })
    noty.show()
    return noty
  }
  return {
    show,
    success: (text, opts = {}) => show(text, 'success', opts),
    error: (text, opts = {}) => show(text, 'error', opts),
    warning: (text, opts = {}) => show(text, 'warning', opts),
    info: (text, opts = {}) => show(text, 'info', opts),
  }
}

export default {
  install(app, opts) {
    const noty = createNoty({ ...defaults, ...opts })
    app.noty = noty
    app.config.globalProperties.$noty = noty
  }
}
